import { Box, Tab, Tabs } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActiveStatusTab,
  selectActiveYardTab,
  selectStatusTabCounts,
  selectYardTabCounts,
} from "../../redux/selector";
import { actions } from "../../redux/slice";
import {
  STATUS_TABS,
  VehicleStatusTab,
  YARD_STATUS_TABS,
  YardStatusTab,
} from "../../types";
import { useStyles } from "./styles";

const StatusTabs = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const activeStatusTab = useSelector(selectActiveStatusTab);
  const counts = useSelector(selectStatusTabCounts);
  const language = (i18n.language || "").toLowerCase();
  const isRtl = language.startsWith("hw") || language.startsWith("he");
  const labelDir = isRtl ? "rtl" : "ltr";

  return (
    <Tabs
      className={styles.tabs}
      value={activeStatusTab}
      onChange={(_, nextValue: VehicleStatusTab) =>
        dispatch(actions.setActiveStatusTab(nextValue))
      }
      variant="standard"
      scrollButtons={false}
    >
      {STATUS_TABS.map((tab) => (
        <Tab
          key={tab}
          value={tab}
          label={
            <Box className={styles.tabLabel} dir={labelDir}>
              <span>{t(tab)}</span>
              {tab === "VECHILE_STATUS.TABS.WAITING_ENTRY" && (
                <span
                  className={
                    tab === activeStatusTab
                      ? styles.tabBadgeActive
                      : styles.tabBadge
                  }
                >
                  {counts[tab]}
                </span>
              )}
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};

export const YardStatusTabs = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const activeYardTab = useSelector(selectActiveYardTab);
  const yardCounts = useSelector(selectYardTabCounts);
  const language = (i18n.language || "").toLowerCase();
  const isRtl = language.startsWith("hw") || language.startsWith("he");
  const labelDir = isRtl ? "rtl" : "ltr";

  return (
    <Tabs
      className={styles.yardTabs}
      value={activeYardTab}
      onChange={(_, nextValue: YardStatusTab) =>
        dispatch(actions.setActiveYardTab(nextValue))
      }
      variant="standard"
      scrollButtons={false}
    >
      {YARD_STATUS_TABS.map((tab) => (
        <Tab
          key={tab}
          value={tab}
          label={
            <Box className={styles.tabLabel} dir={labelDir}>
              <span>{t(tab)}</span>
              <span
                className={
                  tab === activeYardTab
                    ? styles.tabBadgeActive
                    : styles.tabBadge
                }
              >
                {yardCounts[tab]}
              </span>
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};

export default StatusTabs;
